import communityManager from './community-manager.svg';
import coordinator from './coordinator.svg';
import documentalist from './documentalist.svg';
import factchecker from './fact-checker.svg';
import journalist from './journalist.svg';
import undefinedRole from './undefined.svg';

const roleAvatar = {
	'fact-checker': factchecker,
	documentalist,
	journalist,
	coordinator,
	undefined: undefinedRole,
	'community-manager': communityManager
};

export default roleAvatar;
